(function () {
  "use strict";

  var key = "__opdCollectionDefaults";
  if (window[key]) return;
  var availabilityName = "filter.v.availability";
  var conditionName = "filter.p.m.custom.condition";
  var markerName = "opd_state";
  var listeners = [];
  var collectionPathPattern = /^(?:\/[a-z]{2,3}(?:-[a-z0-9]{2,8})*)?\/collections\/([^/]+)(?:\/([^/]+))?\/?$/i;
  var scopeSelector = '.collection-content[data-section-type="collection-grid"]';
  var typeName = "filter.p.m.custom.product_type";
  var noticeKey = "opdNativeTypeNotice";
  var specializedParams = {
    "filter.v.option.weight": "weight",
    "filter.p.m.custom.integrated_system": "integrated_system",
    "filter.p.m.custom.point_type": "point_type",
    "filter.p.m.custom.barrel_type": "barrel_type",
    "filter.p.m.custom.grip_level": "grip_level",
    "filter.p.m.custom.tungsten": "tungsten",
    "filter.p.m.custom.grip_type": "grip_type",
    "filter.p.m.custom.balance": "balance"
  };
  var dartFields = Object.keys(specializedParams).map(function (name) { return specializedParams[name]; });
  var nativeTypes = {
    "Steel Tip Darts": dartFields,
    "Soft Tip Darts": dartFields,
    "Steel Tip Points": ["point_type"],
    "Flights": ["integrated_system"],
    "Shafts": ["integrated_system"],
    "Cases / Wallets": [],
    "Dartboards": [],
    "Apparel": []
  };

  function selectedTypes(url) {
    var values = [];
    url.searchParams.getAll(typeName).forEach(function (entry) {
      entry.split(",").forEach(function (value) { if (value.trim()) values.push(value.trim()); });
    });
    return Array.from(new Set(values));
  }

  function allowedNativeFields(types) {
    if (!types.length || types.some(function (type) { return !Object.prototype.hasOwnProperty.call(nativeTypes, type); })) return null;
    return new Set([].concat.apply([], types.map(function (type) { return nativeTypes[type]; })));
  }

  function paramApplies(name, allowed) {
    return allowed === null || !Object.prototype.hasOwnProperty.call(specializedParams, name) || allowed.has(specializedParams[name]);
  }

  function refreshNativeGroups(scope, current) {
    var types = selectedTypes(current);
    if (!types.length) {
      var evidence = scope.querySelector("[data-opd-native-scope-types]");
      if (evidence) {
        try {
          var values = JSON.parse(evidence.getAttribute("data-opd-native-scope-types"));
          if (Array.isArray(values) && values.length && values.every(function (value) { return typeof value === "string" && value.trim() === value && value; })) types = Array.from(new Set(values));
        } catch (error) {}
      }
    }
    var allowed = allowedNativeFields(types);
    scope.querySelectorAll("[data-opd-native-filter-group]").forEach(function (group) {
      var name = group.getAttribute("data-opd-native-filter-group");
      var selected = current.searchParams.getAll(name).some(function (value) { return value !== ""; });
      var rows = group.querySelectorAll("[data-opd-native-filter-value]");
      var visibleValues = 0;
      rows.forEach(function (row) {
        var input = row.querySelector('input[type="checkbox"]');
        if (!input) return;
        if (name === availabilityName && collectionInfo(current) && collectionInfo(current).handle === "trade-in") {
          var stockValues = current.searchParams.getAll(availabilityName).join(",").split(",");
          if (stockValues.indexOf("0") >= 0 && stockValues.indexOf("1") >= 0) input.checked = true;
        }
        if (input.checked) selected = true;
        var count = Number(row.getAttribute("data-opd-native-count"));
        var hidden = count === 0 && !input.checked;
        row.hidden = hidden;
        row.classList.toggle("hide", hidden);
        input.disabled = hidden;
        if (!hidden) visibleValues++;
      });
      var hidden = !selected && (!paramApplies(name, allowed) || (group.getAttribute("data-opd-native-filter-kind") !== "price_range" && visibleValues === 0));
      if (hidden && group.contains(document.activeElement)) {
        var typeTrigger = scope.querySelector('[data-opd-native-filter-group="' + typeName + '"] button');
        if (typeTrigger) typeTrigger.focus({preventScroll:true});
      }
      group.hidden = hidden;
      group.classList.toggle("hide", hidden);
    });
    var notice = window.history.state && window.history.state[noticeKey];
    scope.querySelectorAll("[data-opd-native-applicability-notice]").forEach(function (node) {
      var text = notice && notice.href === current.href && typeof notice.text === "string" ? notice.text : "";
      node.textContent = text;
      node.hidden = !text;
    });
  }

  function typeTransitionURL(current, form) {
    var next = new URL(current.href);
    var controls = Array.from(form.querySelectorAll('[name="' + typeName + '"]'));
    next.searchParams.delete(typeName);
    controls.forEach(function (input) {
      if (input.disabled || !input.checked || input.value === "") return;
      next.searchParams.append(typeName, input.value);
    });
    return next;
  }

  function commitTypeTransition(next, scope) {
    var types = selectedTypes(next), allowed = allowedNativeFields(types), removed = [];
    Object.keys(specializedParams).forEach(function (name) {
      if (paramApplies(name, allowed) || !next.searchParams.has(name)) return;
      if (next.searchParams.getAll(name).some(function (value) { return value !== ""; })) {
        var group = scope.querySelector('[data-opd-native-filter-group="' + name + '"]');
        removed.push(group ? group.getAttribute("data-opd-native-filter-label") : specializedParams[name].replace(/_/g, " "));
      }
      next.searchParams.delete(name);
    });
    next.searchParams.delete("page");
    next.searchParams.set(markerName, "1");
    var message = removed.length ? removed.join(", ") + (removed.length === 1 ? " was cleared because it does" : " were cleared because they do") + " not apply to " + types.join(" or ") + "." : "";
    var state = Object.assign({}, window.history.state || {});
    state[noticeKey] = { href: next.href, text: message };
    if (window.__opdFilterPanelUI) window.__opdFilterPanelUI.saveNavigation(next.href, window.__opdFilterPanelUI.captureNative());
    window.history.pushState(state, "", next.href);
    window.location.reload();
  }

  function collectionInfo(url) {
    if (url.origin !== window.location.origin || url.searchParams.has("view")) return null;
    var match = url.pathname.match(collectionPathPattern);
    if (!match || match[1] === "out-of-stock") return null;
    if (!match[2] && (match[1] === "dart-points" || match[1] === "steel-tip-darts")) return null;
    return { handle: match[1], tagged: !!match[2] };
  }

  function defaultURL(value) {
    var url = new URL(value, window.location.href);
    var info = collectionInfo(url);
    if (!info || url.searchParams.has(markerName)) return null;
    if (Array.from(url.searchParams.keys()).some(function (name) { return name.indexOf("opd.") === 0; })) return null;
    var changedFilters = false;
    if (!url.searchParams.has(availabilityName)) {
      url.searchParams.set(availabilityName, info.handle === "trade-in" ? "0,1" : "1");
      changedFilters = true;
    }
    if (info.handle !== "all" && !url.searchParams.has(conditionName)) {
      url.searchParams.set(conditionName, info.handle === "trade-in" ? "Used" : "New");
      changedFilters = true;
    }
    url.searchParams.set(markerName, "1");
    return { url: url, changedFilters: changedFilters };
  }

  function normalizeEntry() {
    try {
      var current = new URL(window.location.href), path = current.pathname.match(collectionPathPattern);
      var ordinaryPage = /^[2-9]\d*$|^1\d+$/.test(current.searchParams.get("page") || "");
      var hasState = Array.from(current.searchParams.keys()).some(function (name) { return name === "view" || name === markerName || name === "sort_by" || name.indexOf("filter.") === 0 || name.indexOf("opd.") === 0; });
      if (path && !path[2] && ["steel-tip-darts", "dart-points", "trade-in"].indexOf(path[1]) >= 0 && ordinaryPage && !hasState) {
        current.searchParams.delete("page");
        current.searchParams.set("view", "opd-browse");
        current.searchParams.set("page", new URL(window.location.href).searchParams.get("page"));
        window.location.replace(current.toString());
        return;
      }
      var next = defaultURL(window.location.href);
      if (!next) return;
      if (next.changedFilters) window.location.replace(next.url.toString());
      else window.history.replaceState(window.history.state, "", next.url.toString());
    } catch (error) {}
  }

  function preserveNativeURL(value, current) {
    var url = new URL(value, current);
    if (url.origin !== current.origin || url.pathname !== current.pathname || !collectionInfo(url)) return url;
    Array.from(new Set(current.searchParams.keys())).forEach(function (name) {
      if (name.indexOf("filter.") === 0 || name.indexOf("opd.") === 0 || name === markerName || name === "page" || url.searchParams.has(name)) return;
      current.searchParams.getAll(name).forEach(function (value) { url.searchParams.append(name, value); });
    });
    url.searchParams.set(markerName, "1");
    return url;
  }

  function refresh() {
    var current;
    try { current = new URL(window.location.href); } catch (error) { return; }
    if (!collectionInfo(current)) return;
    document.querySelectorAll(scopeSelector).forEach(function (scope) {
      scope.querySelectorAll(".filter-form").forEach(function (form) {
        form.querySelectorAll("[data-opd-native-default-context]").forEach(function (node) { node.remove(); });
        var preserved = preserveNativeURL(current.pathname, current).searchParams;
        Array.from(new Set(preserved.keys())).forEach(function (name) {
          if (Array.from(form.querySelectorAll("[name]")).some(function (node) { return node.name === name && !node.hasAttribute("data-opd-native-default-context"); })) return;
          preserved.getAll(name).forEach(function (value) {
            var input = document.createElement("input");
            input.type = "hidden"; input.name = name; input.value = value;
            input.setAttribute("data-opd-native-default-context", ""); form.appendChild(input);
          });
        });
      });
      scope.querySelectorAll(".tag-list a[href], .pagination a[href], [data-opd-clear-filters]").forEach(function (link) {
        link.href = preserveNativeURL(link.href, current).toString();
      });
      refreshNativeGroups(scope, current);
    });
  }

  function normalizeTradeInPage() {
    try {
      var url = new URL(window.location.href), info = collectionInfo(url);
      if (!info || info.handle !== "trade-in" || url.searchParams.get(availabilityName) !== "1") return;
      var pagination = document.querySelector("[data-opd-trade-in-pagination]");
      if (!pagination) return;
      var page = Number(url.searchParams.get("page") || "1");
      var renderedPage = Number(pagination.getAttribute("data-opd-current-page"));
      var lastPage = Number(pagination.getAttribute("data-opd-trade-in-pagination"));
      if (!Number.isInteger(page) || !Number.isInteger(lastPage) || lastPage < 1 || page !== renderedPage || page <= lastPage) return;
      if (lastPage === 1) url.searchParams.delete("page");
      else url.searchParams.set("page", String(lastPage));
      window.location.replace(url.toString());
    } catch (error) {}
  }

  function listen(target, type, handler, options) {
    target.addEventListener(type, handler, options);
    listeners.push(function () { target.removeEventListener(type, handler, options); });
  }
  function ready() { refresh(); normalizeTradeInPage(); }
  listen(document, "input", function (event) {
    var form = event.target.closest && event.target.closest(scopeSelector + " .filter-form");
    if (!form) return;
    var current = new URL(window.location.href);
    if (event.target.name === typeName && collectionInfo(current)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      commitTypeTransition(typeTransitionURL(current, form), form.closest(scopeSelector));
      return;
    }
    refresh();
  }, true);
  listen(document, "click", function (event) {
    if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest && event.target.closest("a[href]");
    if (!link || link.target === "_blank" || link.hasAttribute("download")) return;
    try {
      var current = new URL(window.location.href), target = new URL(link.href, current);
      if (link.getAttribute("data-opd-native-active-filter") === typeName && link.closest(scopeSelector) && collectionInfo(current) && target.origin === current.origin && target.pathname === current.pathname) {
        event.preventDefault();
        event.stopImmediatePropagation();
        commitTypeTransition(preserveNativeURL(target, current), link.closest(scopeSelector));
        return;
      }
      if (link.closest(scopeSelector) && link.closest(".tag-list, .pagination, [data-opd-clear-filters]")) {
        link.href = preserveNativeURL(target, current).toString();
        if (link.classList.contains("no-ajax") && window.__opdFilterPanelUI) window.__opdFilterPanelUI.saveNavigation(link.href, window.__opdFilterPanelUI.captureNative());
        return;
      }
      var next = defaultURL(target);
      if (next) {
        var previews = current.searchParams.getAll("preview_theme_id");
        if (!next.url.searchParams.has("preview_theme_id") && previews.length === 1 && /^\d+$/.test(previews[0])) next.url.searchParams.set("preview_theme_id", previews[0]);
        link.href = next.url.toString();
      }
    } catch (error) {}
  }, true);
  listen(document, "collection:reloaded", ready);
  listen(document, "shopify:section:load", refresh);
  listen(window, "pageshow", refresh);
  listen(window, "popstate", function (event) {
    var current;
    try { current = new URL(window.location.href); } catch (error) { return; }
    var views = current.searchParams.getAll("view");
    if (current.origin !== window.location.origin || !collectionPathPattern.test(current.pathname)) return;
    if (views.length && !(views.length === 1 && views[0] === "opd-standard-filters")) return;
    if (!document.querySelector(scopeSelector)) return;
    event.stopImmediatePropagation();
    if (window.__opdFilterPanelUI) window.__opdFilterPanelUI.saveNavigation(current.href, window.__opdFilterPanelUI.captureNative());
    window.location.reload();
  }, true);
  if (document.readyState === "loading") listen(document, "DOMContentLoaded", ready);
  else ready();
  window[key] = { refresh: refresh, destroy: function () { listeners.forEach(function (remove) { remove(); }); delete window[key]; } };
  normalizeEntry();
}());

